export default __webpack_public_path__ + "static/media/P1010746.5fe6e949.jpg";